import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { SystemConstants } from "../common/system.constants";
import { AuthService } from "./auth.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
// import { Observable } from "rxjs";
// import { retry,catchError } from 'rxjs/operators';

@Injectable({
  providedIn: "root",
})
export class DataService {
  //protected apiURLHCOut = SystemConstants.BASE_API_AIH_OUT;
  //protected apiURLHC = SystemConstants.BASE_API_NEW;
  protected apiURL = SystemConstants.BASE_API;

  private headers: Headers;

  constructor(private http: HttpClient, public _authService: AuthService) {
    this.headers = new Headers();
    this.headers.append("Content-Type", "application/json");
  }

  getEndPointsAPI(url) {
    return `${this.apiURL}${url}`;
  }

  post(url: any, params: any) {
    const apiUrl = this.getEndPointsAPI(url);
    var reqHeader = new HttpHeaders({
      // "Content-Type": "application/json",
      Authorization:
        "Bearer " + this._authService.getLoggedInUser().access_token,
    });
    //console.log(apiUrl,reqHeader);
    return this.http.post(apiUrl, params, {
      headers: reqHeader,
    });
  }

  put(url: any, params: any) {
    const apiUrl = this.getEndPointsAPI(url);
    var reqHeader = new HttpHeaders({
      // "Content-Type": "application/json",
      Authorization:
        "Bearer " + this._authService.getLoggedInUser().access_token,
    });
    //console.log(apiUrl,reqHeader);
    return this.http.put(apiUrl, params, {
      headers: reqHeader,
    });
  }

  get(url: any) {
    const apiUrl = this.getEndPointsAPI(url);
    var reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization:
        "Bearer " + this._authService.getLoggedInUser().access_token,
    });
    //console.log(apiUrl,reqHeader);
    return this.http.get(apiUrl, {
      headers: reqHeader,
    });
  }

  delete(url: any) {
    const apiUrl = this.getEndPointsAPI(url);
    var reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization:
        "Bearer " + this._authService.getLoggedInUser().access_token,
    });
    //console.log(apiUrl,reqHeader);
    return this.http.delete(apiUrl, {
      headers: reqHeader,
    });
  }

  postOut(url: any, params: any, reqHeader: any) {
    const apiUrl = url;
    var _reqHeader = new HttpHeaders(reqHeader);
    return this.http.post(apiUrl, params, {
      headers: _reqHeader,
    });
  }

  postOut1(url: any, params: any) {
    const apiUrl = this.getEndPointsAPI(url);
    return this.http.post(apiUrl, params);
  }

  public handleError(error: any) {
    return error;
  }
}
